import { Clock, Download, Upload } from "lucide-react";

const PhaseIndicator = ({ isActive, currentPhase }) => {
  if (!isActive) return null;

  return (
    <div className="text-center mb-6">
      <div className="inline-flex items-center space-x-2 px-4 py-2 bg-[#1E9B4C]/20 dark:bg-[#1E9B4C]/30 rounded-full">
        {currentPhase === 'ping' && <Clock size={16} className="text-[#1E9B4C] dark:text-green-400" />}
        {currentPhase === 'download' && <Download size={16} className="text-[#1E9B4C] dark:text-green-400" />}
        {currentPhase === 'upload' && <Upload size={16} className="text-[#1E9B4C] dark:text-green-400" />}

        <span className="text-sm font-medium text-[#1E9B4C] dark:text-green-400">
          {currentPhase === 'ping' && 'Measuring Latency...'}
          {currentPhase === 'download' && 'Testing Download Speed...'}
          {currentPhase === 'upload' && 'Testing Upload Speed...'}
        </span>
      </div>
    </div>
  );
};

export default PhaseIndicator;